import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getCityStatus = async (params: object) => {
  return await GET({ url: Api.getCityStatus, params, showError: false })
}
